module.exports = __webpack_public_path__ + "img/title.81fe2260.png";